import React from "react";
import { Link, graphql } from "gatsby";
import { GatsbyImage as Image, getImage } from "gatsby-plugin-image";
import { renderContent } from "../../utilities/renderContent";
import CtaButton from "../elements/CtaButton";

export default function LivHowItWorksSection({ data }) {
  const {
    colorBackground,
    colorText,
    ctaLink,
    ctaText,
    header,
    imageBlock,
    subtext,
  } = data;

  const getItemBlocks = (itemBlock) => {
    return (
      <div className="w-full flex max-w-screen-xl my-0 mx-auto px-6 flex-col md:flex-row md:grid grid-cols-3">
        {itemBlock.map((item, index) => {
          return (
          <div className="flex-1 md:pr-6 mb-10 flex-col flex-auto" key={index}>
            
            <div className="text-white bg-primary p-4 rounded-full w-20 h-20 flex justify-center items-center mx-auto text-4xl font-body font-bold mb-4 image-card-headline_simple_setup_section_white">
              {index + 1}
            </div>
            <div className="text-white bg-primary p-4 rounded-full w-20 h-20 flex justify-center items-center mx-auto text-4xl font-body font-bold mb-4 image-card-headline_simple_setup_section">
              {index + 1}
            </div>
            <div className="px-12 md:pl-12 md:px-2 liv-item_content h-full flex-col justify-between">
              <div className="md:flex h-full self-center mt-12 md:mt-8">
                {item.text && (
                    <div
                        dangerouslySetInnerHTML={renderContent(item.text)}
                        style={{ color: colorText.hex }}
                    />
                )}
                {item.image && (
                    <div className="object-cover object-center text-center mt-2 md:mt-20">
                      <Image
                          image={getImage(item.image)}
                          alt={header}
                          className="w-20 h-20"
                      />
                    </div>
                )}
              </div>
            </div>
          </div>
          );
        })}
      </div>
    );
  };

  return (
    <section
      className="hds-container hds-text-color relative z-10 py-8"
      style={{ background: colorBackground.hex }}
    >
      <div className="text-center py-8" style={{ color: colorText }}>
        <h3
          className="font-heading uppercase font-bold leading-tight text-3xl mb-4"
          style={{ color: colorText.hex }}
        >
          {header}
        </h3>
        {subtext && (
          <div
            className="mb-8"
            style={{ color: colorText.hex }}
            dangerouslySetInnerHTML={renderContent(subtext)}
          />
        )}
      </div>
      <div className="w-full md:flex text-left hds-transition flex-col">
        {getItemBlocks(imageBlock)}
        {ctaLink && ctaText && (
          <div className="mt-6 mx-auto text-center">
            <CtaButton link={ctaLink} text={ctaText} />
          </div>
        )}
      </div>
    </section>
  );
}

export const LivHowItWorksQuery = graphql`
  fragment LivHowItWorksSectionComponent on DatoCmsLivHowItWorksSection {
    internal {
      type
    }
    id
    colorText {
      hex
    }
    colorBackground {
      hex
    }
    ctaLink
    ctaText
    header
    subtext
    imageBlock {
      text
      externallink
      image {
        gatsbyImageData
      }
    }
  }
`;
